export default "__VITE_ASSET__D6BHxNwr__"